"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _EditPassengerForm = _interopRequireDefault(require("./EditPassengerForm"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AddPassengerWidget = function AddPassengerWidget(_ref) {
  var sdk = _ref.sdk,
      _ref$onAdd = _ref.onAdd,
      onAdd = _ref$onAdd === void 0 ? function () {} : _ref$onAdd,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      translatorForNamespace = _ref.translatorForNamespace,
      _ref$showAllFields = _ref.showAllFields,
      showAllFields = _ref$showAllFields === void 0 ? false : _ref$showAllFields;
  var t = translatorForNamespace('AddPassengerPopupUI');
  var config = {
    name: {
      title: t('Passenger name'),
      subtitle: t('Will display on your tickets'),
      show: true
    },
    phone: {
      title: t('Phone number'),
      subtitle: t('Used to send ticket information'),
      show: true
    },
    ssn: {
      title: t('Identification document'),
      subtitle: t('Necessary to onboard the bus'),
      show: true
    }
  };

  if (showAllFields) {
    config.email = {
      show: true
    };
    config.address = {
      show: true
    };
  }

  return /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: t('Add passenger')
  }, /*#__PURE__*/_react["default"].createElement(_EditPassengerForm["default"], _extends({
    noWrap: true
  }, {
    sdk: sdk,
    translatorForNamespace: translatorForNamespace,
    submitButtonLabel: t('Add'),
    onSubmit: onAdd,
    leftButtonLabel: t('Back'),
    onLeftButtonClick: onBack,
    leftButtonColor: null,
    config: config
  })));
};

var _default = AddPassengerWidget;
exports["default"] = _default;